import React, { useMemo, useState } from "react"
import ExportExcel from "components/Excelconvert/ExportExcel"

import { useSelector, useDispatch } from "react-redux"
import {
  CardBody,
  Card,
  Row,
  Col,
  CardTitle,
  Badge,
  Modal,
  UncontrolledTooltip,
  Button,
  Container,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"

import moment from "moment"
import { FaEnvelope, FaClock } from "react-icons/fa";

//import components
import TableContainer from "components/Common/TableContainer"
import { useEffect } from "react"

// slice
import {
  TicketBookedHistory,
  resetVenue,
} from "toolkitStore/eventMSlice/VenueSlice"
import { sendBookingMail } from "toolkitStore/eventMSlice/SeatAllocationSlice"

function TicketBooked(props) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const event_id_c = JSON.parse(localStorage.getItem("event_id"))
  // console.log("event_id", event_id_c)
  const venue_id_c = JSON.parse(localStorage.getItem("venue_id"))
  // console.log("venue_id", venue_id_c)

  const { TicketBookedDetails, VenueisSuccessfully } = useSelector(
    state => state.VenueReducer
  )
 



   const { newEventList } = useSelector(state => state.EventReducer)
    const currentEvent = newEventList?.find(ev => ev._id === event_id_c?.EventId)

 

    console.log(`log for  particular event ${currentEvent?.eventTypeId}`)
  useEffect(() => {
    dispatch(TicketBookedHistory(venue_id_c.VenueId))

    dispatch(resetVenue())
  }, [])
 
 



  const columns = useMemo(
    () => [
      // {
      //   Header: "Member ID",
      //   accessor: "sats_member_id",
      //   Cell: cellProps => (
      //     <ul className="list-unstyled hstack gap-3 mb-0 text-center">
      //       <li
      //         className={
      //           cellProps.row.original.sats_member_id
      //             ? "text-dark"
      //             : "text-danger"
      //         }
      //       >
      //         {cellProps.row.original.sats_member_id
      //           ? cellProps.row.original.sats_member_id
      //           : "Non Member"}
      //       </li>
      //     </ul>
      //   ),
      // },
      {
  Header: "Member Status",
  // Use a generic accessor or just access the original row object in Cell
  accessor: "member_type", 
  Cell: cellProps => {
    const row = cellProps.row.original;
    // Check if either ID exists OR if the backend already flagged it as 'member'
    const isMember = row.memberID || row.sats_member_id || row.member_type === "member";
    
    // Determine the display ID (prioritize SATS ID, then Database ID)
 
    return (
      <ul className="list-unstyled hstack gap-3 mb-0 text-center">
        <li className={isMember ? "text-dark" : "text-danger"}>
          {isMember ? (
            <span>
              
               Member
            </span>
          ) : (
            "Non Member"
          )}
        </li>
      </ul>
    );
  },
},
      {
        Header: "First Name",
        accessor: "firstname",
      },
      {
        Header: "Last Name",
        accessor: "lastname",
      },


      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Payment Date",
        accessor: "createdAt",
        Cell: cellProps => {
          return (
            <div>
              {moment
                .parseZone(cellProps.row.original.createdAt)
                .format("MM/DD/YYYY")}
            </div>
          )
        },
      },
      {
        Header: "Tansaction ID",
        accessor: "transaction_id",
      },

      {
        Header: "Adult Member Count",
        accessor: "adult_member_count",
      },
      {
        Header: "Child Member Count",
        accessor: "child_member_count",
      },
      //  {
      //   Header: "Sponsor Count",
      //   accessor: "sponsor_member_count",
      // },
       {
        Header: "Adult Non Member Count",
        accessor: "adult_non_member_count",
      },
      {
        Header: "Child Non Member Count",
        accessor: "child_non_member_count",
      },
      //  {
      //   Header: "Sponsor Non Count",
      //   accessor: "sponsor_non_member_count",
      // },
      {
        Header: "Veg Adult Count",
        accessor: "veg_adult_count",
      },
      {
        Header: "Veg Child Count",
        accessor: "veg_child_count",
      },
      {
        Header: "Non-Veg Adult Count",
        accessor: "nonveg_adult_count",
      },
       {
        Header: "Non-Veg Child Count",
        accessor: "nonveg_child_count",
      },
      {
        Header: "Vegan Adult Member Count",
        accessor: "vegan_adult_member_count",
      },
      {
        Header: "Vegan Child Member Count",
        accessor: "vegan_child_member_count",
      },

      {
        Header: "Vegan Adult Non Member Count",
        accessor: "vegan_adult_non_member_count",
      },
      {
        Header: "Vegan Child Non Member Count",
        accessor: "vegan_child_non_member_count",
      },
 
      {
        Header: "Amount",
        accessor: "net_amount",
        Cell: cellProps => {
          return <div>$ {cellProps.row.original.net_amount}</div>
        },
      },
      {
        Header: "Payment Status",
        accessor: "payment_status",
        Cell: cellProps => {
          // console.log("cellProps.row.original", cellProps.row.original)
          return (
            <ul className="list-unstyled mb-0">
              <div
                className={
                  cellProps.row.original.ticket_payment_status === "initiated"
                    ? "badge badge-soft-secondary"
                    : cellProps.row.original.ticket_payment_status === "failed"
                      ? "badge badge-soft-danger"
                      : "badge badge-soft-success"
                }
              >
                {cellProps.row.original.ticket_payment_status === "initiated"
                  ? "Initiated"
                  : cellProps.row.original.ticket_payment_status === "failed"
                    ? "Failed"
                    : "Success"}
              </div>
            </ul>
          )
        },
      },



 {
  Header: "Send Mail",
  Cell: ({ row }) => {
    const payer = row.original;
    const isSuccess = payer.ticket_payment_status === "success";

    return (
      <Button
        // color="primary"
        size="sm"
        disabled={!isSuccess} // Disable if not success
        title={
          isSuccess
            ? `Send mail to ${payer.email}`
            : "Mail can be sent only after successful payment"
        }
        onClick={() => {
          if (isSuccess && window.confirm(`Send mail to ${payer.email}?`)) {
            
             dispatch(sendBookingMail({ payer_id: payer._id, email: payer.email }));
          }
        }} style={{ backgroundColor: "white",borderColor:"white"  }}
      >
        {/* {isSuccess ? "Send Mail" : "Pending"} */}
        
         {isSuccess ? (
    <FaEnvelope style={{ color: "#0fdc27", fontSize: "18px" }} />
  ) : (
    <FaClock style={{ color: "gray", fontSize: "18px" }} />
  )}
      </Button>
    );
  },
},


    ],
    []
  )

 
 

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Utility" breadcrumbItem="Booked Information" />

          <Row className="">
            <Card>
              <CardBody className="border-botton">
                <div className="d-flex align-items-center">
                  <h5 className="mb-1 card-title flex-grow-1 text-primary">
                    {event_id_c.EventName + " / " + venue_id_c.VenueName}
                  </h5>
                  <div className="mb-1 flex-shrink-0">
                    <ExportExcel
                      excelData={TicketBookedDetails}
                      fileName={"TicketsSales"}
                    />
                    

                    <Link to="/upcomingevents" className="btn btn-secondary me-1">
                      Back
                    </Link>
                    <Link
                      to="#!"
                      onClick={() => {
                        /*  dispatch(fetchServices(userInformation.m_company_id)) */
                      }}
                      className="btn btn-light me-1"
                    >
                      <i className="mdi mdi-refresh"></i>
                    </Link>
                  </div>
                </div>
                <Row>
                  <div className="container-fluid">
                    <TableContainer
                      columns={columns}
                      data={TicketBookedDetails}
                      isGlobalFilter={true}
                      isAddOptions={false}
                      customPageSize={30}
                      isJobListGlobalFilter={false}
                    // className="custom-header-css"
                    />
           

                  </div>
                </Row>
                {TicketBookedDetails.length > 30 ? (
                  <Row>
                    <Col xs="12">
                      <div className="text-center my-3">
                        <Link to="#" className="text-success">
                          <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                          Load more
                        </Link>
                      </div>
                    </Col>
                  </Row>
                ) : null}
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TicketBooked
